import { create } from 'zustand';

interface AccessTokenState {
  token: string | null;
  setToken: (token: string) => void;
  clear: () => void;
}

export const useAccessTokenStore = create<AccessTokenState>((set) => ({
  token: null,
  setToken: (token) => set({ token }),
  clear: () => set({ token: null }),
}));
